var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cart" },
    [
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _c("div", { staticClass: "cart__wrapper" }, [
          _c(
            "div",
            { staticClass: "cart__contents" },
            [
              _c("div", { staticClass: "cart__header" }, [
                _c("div", { staticClass: "cart__count" }, [
                  _vm._v(_vm._s(_vm.cartCountText))
                ]),
                _c("h1", { staticClass: "cart__heading" }, [
                  _vm._v(_vm._s(_vm.heading))
                ])
              ]),
              _vm.totalItems > 0
                ? _c(
                    "transition-group",
                    {
                      key: "contents",
                      staticClass: "cart__items",
                      attrs: { name: "slide-fade-left", tag: "ul" }
                    },
                    _vm._l(_vm.items, function(item, index) {
                      return _c("cart-line-item", {
                        key: item.id,
                        attrs: { item: item, line: index + 1 },
                        on: { "gwp-cancelled": _vm.cancelThresholdProduct }
                      })
                    }),
                    1
                  )
                : _c(
                    "div",
                    { key: "empty", staticClass: "cart__empty" },
                    [
                      _c("p", { staticClass: "cart__empty-text" }, [
                        _vm._v(_vm._s(_vm.emptyText))
                      ]),
                      _vm.emptyCartCtaUrl && _vm.emptyCartCtaText
                        ? _c(
                            "base-button",
                            {
                              staticClass: "cart__empty-cta",
                              attrs: { href: _vm.emptyCartCtaUrl }
                            },
                            [_vm._v(_vm._s(_vm.emptyCartCtaText))]
                          )
                        : _vm._e(),
                      _vm.emptyCartSecondaryCtaUrl &&
                      _vm.emptyCartSecondaryCtaText
                        ? _c(
                            "base-button",
                            {
                              staticClass:
                                "cart__empty-cta cart__empty-cta--secondary button--green",
                              attrs: { href: _vm.emptyCartSecondaryCtaUrl }
                            },
                            [_vm._v(_vm._s(_vm.emptyCartSecondaryCtaText))]
                          )
                        : _vm._e()
                    ],
                    1
                  )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "cart__checkout-column" },
            [
              _c(
                "div",
                { staticClass: "cart__totals" },
                [
                  _c("cart-totals-table"),
                  _vm.promoMessage
                    ? _c("div", {
                        staticClass: "cart__promo-message",
                        domProps: { innerHTML: _vm._s(_vm.promoMessage) }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "cart__form" },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "button--full-width cart__checkout-cta",
                      attrs: {
                        href: _vm.checkoutURL,
                        name: "checkout",
                        type: "submit"
                      }
                    },
                    [_vm._v("Checkout")]
                  )
                ],
                1
              ),
              _c(
                "base-button",
                {
                  staticClass: "button--secondary cart__continue-shopping",
                  attrs: { href: "/collections/all-products" }
                },
                [_vm._v("Continue Shopping")]
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }